export default __webpack_public_path__ + "static/media/content.0ef475fe.csv";